import * as React from 'react'
import { FROM_LEGAL_MONTH, TO_LEGAL_MONTH } from './constants'
import { ISelectDatePicker, IYearAndMonthSelects } from './interface'
import { months } from 'utils/date'
import { useTranslation } from 'react-i18next'

const YearAndMonthSelects = ({
  date,
  onChange,
  fromMonth = FROM_LEGAL_MONTH,
  toMonth = TO_LEGAL_MONTH
}: IYearAndMonthSelects): JSX.Element => {
  const { i18n } = useTranslation()

  const MONTHS = months(i18n.language)

  const YEARS = []
  for (let i = fromMonth.getFullYear(); i >= toMonth.getFullYear(); i--) {
    YEARS.push(i)
  }

  const handleChange = (e: any) => {
    const { form } = e.target
    if (form) {
      const { month, year } = form
      onChange(new Date(year.value, month.value))
    } else {
      onChange(new Date())
    }
  }

  return (
    <div className='DayPicker-Caption'>
      <SelectDatePicker
        className='DayPicker-Caption__select--month'
        name='month'
        handleChange={handleChange}
        date={date.getMonth()}
        periodTime={MONTHS}
      />
      <SelectDatePicker
        className='DayPicker-Caption__select--year'
        date={date.getFullYear()}
        handleChange={handleChange}
        name='year'
        periodTime={YEARS}
      />
    </div>
  )
}

const SelectDatePicker = ({ className, date, handleChange, name, periodTime }: ISelectDatePicker): JSX.Element => (
  <select className={className} name={name} onChange={handleChange} value={date}>
    {periodTime.map((item, i) => (
      <option key={item} value={name === 'year' ? item : i}>
        {item}
      </option>
    ))}
  </select>
)

export default YearAndMonthSelects
